var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyAcceptedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#444444",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1465 7.14639C13.2403 7.05266 13.3674 7 13.5 7C13.6326 7 13.7597 7.05266 13.8535 7.14639L15.8535 9.14639C15.9472 9.24016 15.9999 9.36731 15.9999 9.49989C15.9999 9.63248 15.9472 9.75963 15.8535 9.85339L13.8535 11.8534C13.7592 11.9445 13.6329 11.9949 13.5018 11.9937C13.3707 11.9926 13.2453 11.94 13.1526 11.8473C13.0599 11.7546 13.0073 11.6292 13.0062 11.4981C13.005 11.367 13.0554 11.2407 13.1465 11.1464L14.285 10.0079C14.1903 10.0026 14.0953 9.99989 14 9.99989C11.2385 9.99989 9 12.2384 9 14.9999C9 17.7614 11.2385 19.9999 14 19.9999C16.593 19.9999 18.725 18.0264 18.975 15.4994C19.0025 15.2244 19.224 14.9999 19.5 14.9999C19.776 14.9999 20.002 15.2249 19.9795 15.4999C19.7255 18.5799 17.1455 20.9999 14 20.9999C10.6865 20.9999 8 18.3134 8 14.9999C8 11.6864 10.6865 8.99989 14 8.99989C14.1007 8.99989 14.2007 9.00239 14.3 9.00739L13.1465 7.85339C13.0528 7.75963 13.0001 7.63248 13.0001 7.49989C13.0001 7.36731 13.0528 7.24016 13.1465 7.14639ZM16.3535 13.1464C16.4472 13.2402 16.4999 13.3673 16.4999 13.4999C16.4999 13.6325 16.4472 13.7596 16.3535 13.8534L13.6035 16.6034C13.5097 16.6971 13.3826 16.7498 13.25 16.7498C13.1174 16.7498 12.9903 16.6971 12.8965 16.6034L11.6465 15.3534C11.5554 15.2591 11.505 15.1328 11.5062 15.0017C11.5073 14.8706 11.5599 14.7452 11.6526 14.6525C11.7453 14.5598 11.8707 14.5072 12.0018 14.5061C12.1329 14.5049 12.2592 14.5553 12.3535 14.6464L13.25 15.5429L15.6465 13.1464C15.7403 13.0527 15.8674 13 16 13C16.1326 13 16.2597 13.0527 16.3535 13.1464Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyAcceptedIcon);
export default __webpack_public_path__ + "static/media/GreyAcceptedIcon.f62a7fe39e4c9bd3a48f6916d7cfd7ee.svg";
export { ForwardRef as ReactComponent };